import { Controller } from 'stimulus';
import { useDispatch, useHover } from 'stimulus-use';

export default class extends Controller {
  static targets = ['inner'];
  static values = {
    index: Number,
  }

  connect() {
    useDispatch(this);
    this.mute = true;
  }

  sendMute() {
    if (this.mute == true) {
      this.dispatch('demute', { index: this.indexValue });
      this.showSpeaker();
    } else {
      this.dispatch('mute', { index: this.indexValue });
      this.showMute();
    }
  }

  showSpeaker() {
    this.element.classList.remove('videomute--mute');
    this.mute = false;
  }

  showMute() {
    this.element.classList.add('videomute--mute');
    this.mute = true;
  }
}

